import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Parameters } from '../../common/models/parameter.model';
import { RouterConstants } from '../../core/routing/constants/app-paths.constant';
import { DetailService } from '../../core/routing/services/details/detail.service';
import { LoginService } from '../../core/routing/services/login/login.service.ts.service';
import { User } from '../account/login/_models/user.model';
import { RetailService } from './../../core/routing/services/retail_api/retail.service';
import { StoresService } from './../../core/routing/services/stores_api/stores.service';
import { AppGlobal } from './../../core/state/app-global';
import { RetailHqConfiguration } from './../users/interface/retail.i';
import { CreateAccountConstants } from '../account/create-account/constants/create-account.const';
import { LANGUAGE_MAPPINGS } from '../../common/constants/language-mappings.const';
import { MyAccountService } from '../../core/routing/services/my-account/my-account.service';
import { Utils } from '../../common/utils/utils';
import { Chart } from 'angular-highcharts';
import { Options } from 'highcharts';
import { Device } from './../devices/interface/devices-interface.i';
import { DevicesService } from '../../core/routing/services/devices/devices.service';
import { GlobalConstants } from '../../common/constants/global.constant';
import { countryCodeDimension } from '../../common/constants/country-index-GA';
import { countryCode } from '../../common/constants/country-code-GA';
import { GoogleAnalyticsService } from '../google-analytics/google-analytics.service';
import { CommonService } from '../../../../src/app/common/services/common.service';
import { LanguageConstants } from '../header/constants/lang.consts';
import { StoresConstant } from '../../../app/core/routing/services/stores_api/constants/stores.constant';
import { RetailStoreConstants } from '../../../app/core/routing/services/retail_api/constants/retailHq.constants';

@Component({
  selector: 'iposcen-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy {
  firstName: string;
  cognitoId: String;
  parameters: Parameters[];
  userInfo: User;
  configurations: RetailHqConfiguration;
  isHideUpdate: boolean;
  hideUpdates: string;
  userConfigurations = {};
  userDetails: [];
  showOrHideCard: boolean;
  inputParams = {};
  isAnalyticsEnabled: boolean;
  userRole: string;
  languageName: string;
  languageCode: string;
  chart: Chart;
  options: Options;
  allDevicesData = [];
  connectedDevicesCount: string;
  disconnectedDevicesCount: string;
  twoWeeksDisconnectedDevicesCount: string;
  totalDevicesCount: string;
  connectedLabel: string;
  disconnectLabel: string;
  activeLabel: string;
  devicesLabel: string;
  location: string;
  regionalUserDetails = [];
  srtUserDetails = [];
  regionalDisplay = [];
  regionalPopupRetailerIds = [];
  selectedRegionalHq: string;
  regionalList = []
  openRegionalPopup: boolean;
  showRetailGif = false;
  isLoading = false;
  regionalMapIDs = {};
  iposVersion: string;
  getRetailerPopUpData: any;
  retailerNameData = [];
  retailIdData = [];
  latestReleaseDate: string;
  userId = sessionStorage.getItem('userId');
  iposLegalVersion: string;
  timeZone: any = Intl.DateTimeFormat().resolvedOptions().timeZone;
  retailerConfiguration: any;

  private ngUnsubscribe = new Subject<boolean>();

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private detailService: DetailService,
    private userServie: LoginService,
    private route: Router,
    private retailHqService: RetailService,
    private storeService: StoresService,
    private appGlobal: AppGlobal,
    private myAccountService: MyAccountService,
    private devicesService: DevicesService,
    private cmnService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.getUpdatedTimeYear();
    this.location = sessionStorage.getItem('location');
    this.userRole = sessionStorage.getItem('userRole');
    if (this.userRole !== GlobalConstants.SRT_ADMIN) {
      if ((this.userRole === 'retailHQUser' || this.userRole === 'storeUser' || this.userRole === 'deviceExecutive')) {
        this.getAllDevicesByUserId();
      } else if (this.userRole === 'regionalHQ' && this.cmnService.selectedRegionalRetailerName !== undefined) {
        this.getAllDevicesByUserId();
      }
    }
    this.connectedLabel = GlobalConstants.CONNECTED_TEXT;
    this.disconnectLabel = GlobalConstants.DISCONNECTED_TEXT;
    this.activeLabel = GlobalConstants.ACTIVE_TEXT;
    this.devicesLabel = GlobalConstants.DEVICES_TEXT;
    this.showOrHideCard = false;
    this.firstName = sessionStorage.getItem('firstname');
    // TODO:Added below code for time being, need to replace with proper structure,
    if (sessionStorage.getItem('user')) {
      const obj = JSON.parse(sessionStorage.getItem('user')) as User;
      this.appGlobal.setCurrentUser(obj);
    }
    this.getAllUserDetails();
    this.getLoggedInUserDetails();
    this.languageCode = (localStorage.getItem('preferredLanguage')) ? localStorage.getItem('preferredLanguage') : '';
    this.languageName = (localStorage.getItem('preferredLanguageName')) ? localStorage.getItem('preferredLanguageName') : '';
    this.cmnService.getRetailerListPopupFlag
      .subscribe(res => {
        this.openRegionalPopup = res;
      });
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
          this.showRetailGif = data;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  logout() {
    this.userServie.logout();
    this.detailService.setLayoutToMain(true);
  }

  navigateToCreateProfile() {
    this.route.navigate([RouterConstants.CREATE_PROFILE_LINK]);
  }

  getAllUserDetails() {
    // Get the existing user object
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        if(this.userInfo?.configurations) {
          this.retailerConfiguration = JSON.parse(this.userInfo?.configurations);
          this.isAnalyticsEnabled = (this.retailerConfiguration?.analyticsUrl) ? true : false;
        }
      });

    if (this.userInfo.role === 'retailHQUser' || this.userInfo.role === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE ) {
      this.getRetailerInfoId();
    } else if (this.userInfo.role === 'storeUser') {
      this.storeService.getAllStoresInfoById(this.userInfo.userId, this.userInfo.retailerID, this.userInfo.storeID)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllStoreHqResponse => {
          if (getAllStoreHqResponse) {
            this.getRetailerInfoId();
          }
        }, error => {
        });
    } else if (this.userInfo.role === 'intelAdmin') {
      this.showOrHideCard = true;
    } else if (this.userInfo.role === 'regionalHQ') {
      this.showOrHideCard = false;
    } else {
      // non connected user this.changeCardWidth = true;
      this.showOrHideCard = true;
    }
  }

  getRetailerInfoId() {
    let retailerId = this.userInfo.retailerID;
    if (this.userInfo.role === 'regionalHQ' || this.userInfo.role === GlobalConstants.SRT_ADMIN) retailerId = sessionStorage.getItem('retailerId');
    this.retailHqService.getAllRetailerInfoById(retailerId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllRetailHqResponse => {
        if (getAllRetailHqResponse) {
          this.configurations = JSON.parse(getAllRetailHqResponse.retailer.configurations) as RetailHqConfiguration;
          this.userInfo.isRemoveEnabled = this.configurations.removeEnabled;
          this.userInfo.isCompRxtEnabled = this.configurations.compRxtEnabled;
          this.isAnalyticsEnabled = this.configurations.analyticsUrl ? true : false;
          this.userInfo.configurations = getAllRetailHqResponse.retailer.configurations; //Saving Retail HQ user's configurations in app-global
          this.appGlobal.setCurrentUser(this.userInfo);
        }
      }, error => {
      });
  }

  navigateToHelpPage() {
    this.route.navigate([RouterConstants.HELP_LINK]);
  }

  isHideUpdatesChecked(data) {
    this.showRetailGif = false;
    this.isHideUpdate = data.currentTarget.checked;
    const yesNoText = data.currentTarget.checked ? CreateAccountConstants.TEXT_YES : CreateAccountConstants.TEXT_NO;
    this.userConfigurations = Object.assign(this.userConfigurations, { hide_updates: yesNoText });
    this.inputParams = Object.assign(this.inputParams, { configurations: JSON.stringify(this.userConfigurations) });
    this.myAccountService.updateAccountDetail(this.inputParams)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userResponse => {
        this.showRetailGif = false;
        // Do something
      });
  }
  getLoggedInUserDetails() {
    this.myAccountService.getUserAccountDetails()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userDetailsResponse => {
        // Get language of logged in user
        this.regionalUserDetails = userDetailsResponse.user;
        if (this.userRole === 'regionalHQ' || this.userRole === GlobalConstants.SRT_ADMIN) {
          let UnSortedData = {};
          this.cmnService.displayRegionalDetails(this.regionalUserDetails);
          let retailerMapNames = this.regionalUserDetails['retailerName'].split(",");
          let retailerMapIds = this.regionalUserDetails['retailerID'].split(",");
          retailerMapNames.forEach((e, i) => {
            UnSortedData[e] = retailerMapIds[i]
          });
          this.getMappedRetailerData(UnSortedData);
        }
        const preferredLanguage = userDetailsResponse.user.language;
        if (preferredLanguage !== this.languageCode && this.languageCode !== '') {
          const inputParams = {
            language: this.languageCode
          };
          this.myAccountService.updateAccountDetail(inputParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(userResponse => {
              // Do something
            },
              error => {
                Utils.handleError(error, this.constructor.name);
              }
            );
        }

        if (this.languageCode === '') {
          let languageCode = LANGUAGE_MAPPINGS.find(element => element.langCode === preferredLanguage).langCode;
          if (languageCode === 'zh-tw') {
            languageCode = 'zh-Hant'
          } else if (languageCode === 'zh-cn') {
            languageCode = 'zh-Hans'
          }
          localStorage.setItem('preferredLanguage', languageCode);
          localStorage.setItem('preferredLanguageName', LanguageConstants.SELECTED_LANGUAGE_NAME);
          const routeLink = `/${localStorage.getItem('preferredLanguage')}/home`;
          location.assign(routeLink);
        }

        this.firstName = userDetailsResponse.user.firstName;
        this.inputParams = {
          firstName: userDetailsResponse.user.firstName,
          lastName: userDetailsResponse.user.lastName
        };
        this.userConfigurations = JSON.parse(userDetailsResponse.user.configurations);
        this.hideUpdates = JSON.parse(userDetailsResponse.user.configurations).hide_updates;
        this.isHideUpdate = (this.hideUpdates === '' || this.hideUpdates === undefined || this.hideUpdates === null ||
          this.hideUpdates === CreateAccountConstants.TEXT_NO) ? false : true;
        this.cmnService.setRetailGifValue(false);
      });
  }

  // TODO:Added below code for time being, need to replace with proper structure
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    sessionStorage.setItem('user', JSON.stringify(this.userInfo));
  }

  redirectToUrl() {
    if (!this.configurations.analyticsUrl.includes('https://')) {
      const url = `https://${this.configurations.analyticsUrl}`;
      window.open(url, '_blank');
    }
    else {
      const url = `${this.configurations.analyticsUrl}`;
      window.open(url, '_blank');
    }
  }

  navigateToDevices() {
    this.route.navigate([RouterConstants.DEVICE_DASHBOARD_LINK]);
  }

  makeChartData() {
    this.options = {
      chart: {
        plotBackgroundColor: undefined,
        plotBorderWidth: undefined,
        plotShadow: false,
        type: 'pie',
        borderRadius: 5,
        height: 200,
        width: 400,
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          innerSize: '90%',
          dataLabels: {
            enabled: false
          },
          showInLegend: true,
          colors: ['#8BAE46', '#EDB200', '#C81326']
        }
      },
      title: {
        text: `<span class="device-count">${this.totalDevicesCount}</span> <br>${this.devicesLabel}`,
        verticalAlign: 'middle',
        align: 'center',
        x: -100,
        y: 20
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        symbolHeight: 24,
        symbolWidth: 24,
        symbolRadius: 5,
        padding: 3,
        itemMarginTop: 15,
        itemMarginBottom: 15,
        useHTML: true,
        itemStyle: {
          lineHeight: '7px',
          textOverflow: 'visible',
          color: '#525252',
          fontWeight: 'normal',
          width: 180
        }
      },
      series: [
        {
          colorByPoint: true,
          type: 'pie',
          data: [
            {
              name: `<b>${this.connectedDevicesCount}</b>&nbsp; ${this.connectedLabel}`,
              y: +this.connectedDevicesCount
            },
            {
              name: `<b>${this.disconnectedDevicesCount}</b>&nbsp; ${this.disconnectLabel}`,
              y: +this.disconnectedDevicesCount
            },
            {
              name: `<b>${this.twoWeeksDisconnectedDevicesCount}</b><div style="line-height:1em;margin-left:7px;margin-top:-3px;">${this.activeLabel}</div>`,
              y: +this.twoWeeksDisconnectedDevicesCount
            }
          ]
        }
      ]
    };
    const chart = new Chart(this.options);
    this.chart = chart;
  }

  getAllDevicesByUserId() {
    this.devicesService.getAllDevicesStatus()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllDevicesResponse => {
        this.allDevicesData = getAllDevicesResponse as Device[];
        this.connectedDevicesCount = getAllDevicesResponse.connectedDevicesCount;
        this.disconnectedDevicesCount = getAllDevicesResponse.disconnectedDevicesCount;
        this.twoWeeksDisconnectedDevicesCount = getAllDevicesResponse.twoWeeksDisconnectedDevicesCount;
        this.totalDevicesCount = getAllDevicesResponse.totalDevicesCount;
        this.makeChartData();
      });
  }

  selectRegionalHQ(data) {
    this.selectedRegionalHq = data;
    this.cmnService.displayRegionalRetailerIDs(this.regionalMapIDs[data]);
    sessionStorage.setItem('retailerId', this.regionalMapIDs[data]);
    sessionStorage.setItem('retailerName', data);
    this.cmnService.setRetailerListPopupFlag(false);
    this.cmnService.selectedRegionalRetailerName = data;
    this.cmnService.displaySelectedRegionalDetails(this.selectedRegionalHq);
    if (this.userRole !== GlobalConstants.SRT_ADMIN) {
      this.getAllDevicesByUserId();
    }
    if (this.userRole === GlobalConstants.SRT_ADMIN) {
      this.route.navigateByUrl(RouterConstants.DEVICE_DASHBOARD_LINK);
    }
    this.getRetailerInfoId();
    this.googleAnalyticsService.login();
  }

  getUpdatedTimeYear() {
    this.retailHqService.getDateandYear()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getHomePageResponse => {
        this.iposVersion = getHomePageResponse?.iposVersion;
        this.latestReleaseDate = getHomePageResponse?.latestReleaseDate;
        // for Story IIT2-10209
        this.iposLegalVersion = getHomePageResponse?.iposLegalVersion;
      });
  }

  getMappedRetailerData(unSortedRetailerData) {
    this.regionalMapIDs = Object.keys(unSortedRetailerData).sort().reduce(
      (acc, key) => ({ ...acc, [key]: unSortedRetailerData[key] })
      , {}
    );
    this.regionalDisplay = Object.keys(this.regionalMapIDs);
    this.regionalPopupRetailerIds = Object.values(this.regionalMapIDs);
  }
}
